import dom from '../../utils/dom';
import TnewHpaIframe from './HostedPaymentIframe';
import { loadModal } from '../../AsyncLoader';

/**
 * @param {string} loadingMessage
 */
const buildElements = (loadingMessage) => {
  const $container = dom.makeElement('div');

  const $loading = dom.parseElement(`
    <div class="tn-loader alert-warning">
      <div class="tn-loader-icon"></div> ${loadingMessage}
    </div>
  `);

  const $iframeWrapper = dom.makeElement('div', {
    class: 'tn-hosted-payment-window',
  });

  return {
    $container,
    $loading,
    $iframeWrapper,
  };
};


const scrollToTop = () => {
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
};


function assembleElements({
  $iframe,
  $iframeWrapper,
  $container,
  $loading,
}) {
  $iframeWrapper.appendChild($iframe);
  $container.appendChild($loading);
  $container.appendChild($iframeWrapper);
}

/**
 * @param {object} config
 * @param {string} config.iframeSrc
 * @param {string} config.iframeOrigin
 * @returns {Promise<{wasCancelled: boolean}>}
 */
const open = async ({ iframeSrc, iframeOrigin }) => {
  const Modal = await loadModal();

  const labels = {
    modalTitle: 'Enter Your Payment Information',
    loadingMessage: 'Please Wait',
  };

  const modalOpenBodyClass = 'tn-payment-modal-open';

  const { $container, $loading, $iframeWrapper } = buildElements(labels.loadingMessage);

  return new Promise((resolve) => {
    const iframe = TnewHpaIframe.create(iframeSrc, iframeOrigin, {
      timeoutDuration: 30000,
      onReady: () => dom.hide($loading),
      scrollToTop,
      onPaymentProcessed: () => {
        resolve({ wasCancelled: false });
      },
    });

    assembleElements({
      $container,
      $loading,
      $iframeWrapper,
      $iframe: iframe.$el,
    });

    iframe.load();

    scrollToTop();

    Modal.open({
      title: labels.modalTitle,
      closeOnBackdrop: false,
      bodyContents: $container,
      className: 'tn-payment-modal',
      beforeOpen: () => {
        document.body.classList.add(modalOpenBodyClass);
      },
      beforeClose: () => {
        document.body.classList.remove(modalOpenBodyClass);

        iframe.stopListening();

        if (iframe.getIsPaymentProcessed()) {
          return;
        }

        resolve({ wasCancelled: true });
      },
    });
  });
};


export default {
  open,
};



// WEBPACK FOOTER //
// ./src/onePageGiving/hostedPayment/HostedPaymentIframeModal.js